import { ExcludedPlatforms } from 'app/types/excludedPlatforms'
import { ColorEnum } from 'app/utils/mapColors'
import { gql } from 'graphql-request'

import { GenericBlock } from './generic'

export const bannerFragment = gql`
  fragment bannerFragment on Banner {
    id
    title
    description
    ctaLabel
    href
    theme
    reverse
    bannerBackgroundColour: backgroundColour
    bannerForegroundColour: foregroundColour
    image {
      id
      url
    }
    secondaryTitle
    secondaryDescription
    secondaryCtaLabel
    secondaryHref
    secondaryImage {
      id
      url
    }
    backgroundPattern
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface Banner extends GenericBlock<'Banner'> {
  title: string
  description: string
  ctaLabel: string
  href: string
  reverse: boolean
  theme:
    | 'default'
    | 'sideBySide'
    | 'fullWidthHover'
    | 'rainbow'
    | 'customColour'
  image: {
    id: string
    url: string
  }
  secondaryTitle?: string
  secondaryDescription?: string
  secondaryCtaLabel?: string
  secondaryHref?: string
  secondaryImage?: {
    id: string
    url: string
  }

  backgroundColour?: ColorEnum
  foregroundColour?: ColorEnum
  // Aliases dont work?
  bannerBackgroundColour?: ColorEnum
  bannerForegroundColour?: ColorEnum

  excludedPlatforms?: ExcludedPlatforms
  backgroundPattern?: 'none' | 'pink' | 'darkGreen' | 'cream' | 'blue'
}
